import React from 'react';
import PropTypes from 'prop-types';
import { CircularProgress } from '@mui/material';
import AppBox from '../Box/AppBox';

/**
 * AppProgress — Design System inline loading indicator.
 *
 * For a page-level/blocking load use `CustomLoader`; this is the small spinner
 * for a single panel or region that loads on its own (preview panes, inline
 * fetches) so pages don't have to reach for MUI's CircularProgress directly.
 *
 * @param {number}  size    Spinner diameter in px (default 28)
 * @param {string}  color   MUI palette key (default 'primary')
 * @param {boolean} center  Centre the spinner inside its parent's full box
 * @param {object}  sx      Extra sx on the spinner
 */
const AppProgress = ({ size = 28, color = 'primary', center = false, sx, ...props }) => {
  const spinner = <CircularProgress size={size} color={color} sx={sx} {...props} />;

  if (!center) return spinner;

  return (
    <AppBox
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        height: '100%',
      }}
    >
      {spinner}
    </AppBox>
  );
};

AppProgress.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string,
  center: PropTypes.bool,
  sx: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
};

export default AppProgress;
